import triggerQualtrics from 'helpers/triggerQualtrics'
import { atom } from 'jotai'
import { ModalState, Modals } from './typings'

export const modalAtom = atom<ModalState>({
  modalId: '',
  modalTriggerId: '',
  metadata: {}
})

export const modalStatusAtom = atom(
  (get) => get(modalAtom),
  (
    get,
    set,
    modalId: Modals,
    modalTriggerId: string = '',
    metadata: Record<string, unknown> = {}
  ) => {
    triggerQualtrics()
    set(modalAtom, {
      ...get(modalAtom),
      modalId,
      modalTriggerId,
      metadata
    })
  }
)
